import React from 'react'
import Styles from '../../styles/main.module.css'
import "typeface-source-sans-pro"
import cx from 'classnames'

const Footer = () => (
    <footer id="footer" className={cx(Styles.footer, Styles.asterisk)}>
        <p className={cx(Styles.copyright, Styles.asterisk, Styles.p)}>
            <a href="https://www.instagram.com/aryaaaarmdn/" target="_blank" rel="noopener noreferrer" className={Styles.a}>Aryaaaarmdn</a> &copy; 2020, dibuat dengan GatsbyJS
        </p>
        <br />
    </footer>
)

export default Footer